export enum UserActionType {
  GetUserInfo = 'USER_GET_PROFILE',
  GetUserInfoSuccess = 'USER_GET_PROFILE_SUCCESS',
  GetUserInfoFailure = 'USER_GET_PROFILE_FAILURE',
  RestoreUserInfo = 'RESTORE_USER_INFO',

  PostSignAgreement = 'USER_POST_SIGN_AGREEMENT',
  PostSignAgreementSuccess = 'USER_POST_SIGN_AGREEMENT_SUCCESS',
  PostSignAgreementFailure = 'USER_POST_SIGN_AGREEMENT_FAILURE',
}